
import api from '@/services/api';
import Swal from 'sweetalert2';
import { Place } from '@/store/weather/types';
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';
import BaseSpinner from './UI/BaseSpinner.vue';

@Options({
  components: { BaseSpinner },
  props: ['show'],
  emits: ['on-close'],
  methods: {
    ...mapActions(['getWeatherByPlace']),
  },
})
export default class extends Vue {
  show!: boolean;

  getWeatherByPlace!: (place: Place) => void;

  isInputFocused = false;

  searchQuery = '';

  places: Place[] = [];

  isLoading = false;

  handleClose(e: Event) {
    this.$emit('on-close', e);
  }

  handleInputFocus() {
    this.isInputFocused = true;
  }

  handleInputBlur() {
    this.isInputFocused = false;
  }

  async getLocations() {
    if (this.searchQuery) {
      this.isLoading = true;
      try {
        const { data } = await api.get('find_places', {
          params: {
            text: this.searchQuery,
            language: 'en'
          },
        });

        this.places = data.slice(0, 5).map((place: any) => ({
          placeId: place.place_id,
          name: place.name,
        }));
      } catch (error) {
        Swal.fire({
          title: 'Error!',
          icon: 'error',
          text: `Error while searching locations: ${error.message}`,
        });
      } finally {
        this.isLoading = false;
      }
    }
  }

  getNewData(place: Place, event: Event) {
    this.getWeatherByPlace(place);
    this.handleClose(event);
  }
}
